TS.ns('WL');

WL.leasingOfferServicesModel = new Class({
    Extends: WL.documentBase,

    createProperties: function (config) {  
        var me = this;

        me.parent(config);

        var commissionList = me.getDomainProperty('dgCommissionCollection_Property');
        if (commissionList) {
            commissionList.getFieldByName('gcPartner_Field').allowInput = false;
        }
        
        var leasingExpensesList = me.getDomainProperty('dgLeasingExpenseCollection_Property');
        if (leasingExpensesList) { 
            leasingExpensesList.on('afterAdd', me.onExpenseAdded);
            leasingExpensesList.on('cellValueChanged', me.onLeasingExpenseTypeChanged); 
            leasingExpensesList.on('cellBeginEdit', me.onLeasingExpenseBeginEdit);   
            leasingExpensesList.on('cellBeginEdit', me.expensesCollection_onCellBeginEdit);  

            cat = leasingExpensesList.Commands;
            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'DeleteExpense';
            newCmd['Text'] = 'Delete';
            newCmd['handler'] = 'deleteExpense';
            newCmd['IconCode'] = 'remove';   
            if (!me.ReadOnly())
            cat.push(newCmd);
        } 

        var serviceList = me.getDomainProperty('dgServiceDetailCollection_Property');
        if (serviceList) {
            serviceList.on('afterAdd', me.onServicesAdded);
            serviceList.on('cellValueChanged', me.onServiceDetailChanged);
            serviceList.on('cellBeginEdit', me.onServiceCellBeginEdit);
            serviceList.on('cellBeginEdit', me.serviceCollection_onCellBeginEdit);

            cat = serviceList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'ComputeServices';
            newCmd['Text'] = 'Calculate';
            newCmd['handler'] = 'computeServices';
            newCmd['IconCode'] = 'calculator';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'DeleteServiceDetail';
            newCmd['Text'] = 'Delete';
            newCmd['handler'] = 'deleteServiceDetail';
            newCmd['IconCode'] = 'remove';    
            if (!me.ReadOnly()) 
                cat.push(newCmd); 
        }

        var commissionList = me.getDomainProperty('dgCommissionCollection_Property');
        if (commissionList) {                     
            commissionList.on('cellValueChanged', me.onCommissionChanged);   
            commissionList.on('afterAdd', me.onCommissionAdded, me);
            commissionList.on('cellBeginEdit', me.commissionCollection_onCellBeginEdit);

            comCat = commissionList.Commands;
            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'ComputeCommissions';
            newCmd['Text'] = 'Calculate';
            newCmd['handler'] = 'computeCommissions';
            newCmd['IconCode'] = 'calculator';
            if (!me.ReadOnly())
                comCat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'DeleteCommissions';
            newCmd['Text'] = 'Delete';
            newCmd['handler'] = 'deleteCommissions';
            newCmd['IconCode'] = 'remove';
            if (!me.ReadOnly())
                comCat.push(newCmd);           
        }
    },

    commissionCollection_onCellBeginEdit: function (e) {
        if (e.record.ReadOnlyYN != undefined && e.record.ReadOnlyYN() == true)
            e.preventDefault();
    },

    serviceCollection_onCellBeginEdit: function (e) {
        if (e.record.ReadOnlyYN != undefined && e.record.ReadOnlyYN() == true)
            e.preventDefault();
    },

    expensesCollection_onCellBeginEdit: function (e) {
        if (e.record.ReadOnlyYN != undefined && e.record.ReadOnlyYN() == true)
            e.preventDefault();
    },

    onServiceDetailChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.fieldName == 'ServiceTypeId') {
            owner.performServerCommand('RefreshLeasingServiceType', true, { NewValue: val, rowIdx: e.rowIdx });
        }

        if (e.fieldName == 'ServicePercent') {
            owner.performServerCommand('ComputeServiceAmountOnPercentChanged', true, { NewValue: val, rowIdx: e.rowIdx });
        }

        if (e.fieldName == 'ServiceAmount') {
            owner.performServerCommand('ComputeServicePercentOnAmountChanged', true, { NewValue: val, rowIdx: e.rowIdx });
        }
    },

    onServiceCellBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;
        if (e.fieldName == "ServiceTypeId") {
            if (me.SelectedItem() == null) {
                e.preventDefault();
            }

            if (me.SelectedItem() != null && me.SelectedItem().ServiceTypeId() != null && me.SelectedItem().ServiceTypeReadOnly()) {
                e.preventDefault();
            }
        }
    },

    onLeasingExpenseBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;
        if (e.fieldName == "VATId") {
            if (me.SelectedItem() != null && !owner.CanEditVATQuota()) {
                e.preventDefault();
            } 
        }
    },

    onLeasingExpenseTypeChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.fieldName == 'LeasingExpenseTypeId') {
            owner.performServerCommand('RefreshLeasingExpenseType', true, { NewValue: val, rowIdx: e.rowIdx });
        }
    },

    onCommissionChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.fieldName == 'CalculationMethodId') {
            owner.performServerCommand('RefreshCalculationMethod', true, { NewValue: val, rowIdx: e.rowIdx });
        }


        if (e.fieldName == 'CommissionPercent') {
            owner.performServerCommand('ComputeCommissionAmountOnPercentChanged', true, { NewValue: val, rowIdx: e.rowIdx });
        }

        if (e.fieldName == 'CommissionAmount') {
            owner.performServerCommand('ComputeCommissionPercentOnAmountChanged', true, { NewValue: val, rowIdx: e.rowIdx });
        }
    },

    computeServices: function (e) {  
        var me = this;

        if (me.dgServiceDetailCollection_Property.SelectedItem() == null) {
            TS.MsgBox.show("", me.NoServiceSelectedMessage(), null);
        }
        else {
            var service = me.dgServiceDetailCollection_Property.SelectedItem();

            if (service != null) {
                me.performServerCommand('ComputeServices', true, { SelectedItemUID: service.uid });
            }
        }
    },

    computeCommissions: function () {
        var me = this;
          
        me.performServerCommand('ComputeCommissions', true, null);
    },

    deleteCommissions: function () {
        var me = this;

        var commission = me.dgCommissionCollection_Property.SelectedItem();

        if (commission != null) {
            me.performServerCommand('DeleteCommissions', true, { UID: commission.uid });
        }
    },

    deleteServiceDetail: function () {
        var me = this;

        var service = me.dgServiceDetailCollection_Property.SelectedItem();

        if (service != null) {
            me.performServerCommand('DeleteServiceDetail', true, { UID: service.uid });
        }
    },

    deleteExpense: function () {
        var me = this;

        var expense = me.dgLeasingExpenseCollection_Property.SelectedItem();

        if (expense != null) {
            me.performServerCommand('DeleteExpense', true, { UID: expense.uid });
        }
    },

    onCommissionAdded: function (e) {
        var me = this;                          
        e.item.CurrencyId(me.Document.CurrencyId());
        e.item.CurrencyCode(me.Document.CurrencyCode());
        me.performServerCommand("Dummy", true, null, null, false, true);        
    },

    onExpenseAdded: function () {
        var me = this,
            owner = me._getOwner();
        owner.performServerCommand("Dummy", true, null, null, false, true);      
    },

    onServicesAdded: function () {
        var me = this,
            owner = me._getOwner();
        owner.performServerCommand("Dummy", true, null, null, false, true);       
    },
   
});
